module.exports = __webpack_public_path__ + "static/schuurbeiz-c5a5f6515b6acc0bf2e6b252dd9ce120.jpg";